<template>
  <div class="preorder-window-component">
    <h1 class="step-title font-weight-regular">
      Предзаказ:
    </h1>

    <div class="button-group d-flex justify-between">
      <v-row dense class="justify-space-between">
        <v-col sm="5">
          <v-btn
            @click="stepBack"
            class="button button-back"
            width="100%"
            color="#F1F3F6"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
        <v-col sm="5">
          <v-btn
            @click="applyPreorder"
            class="button button-apply"
            width="100%"
            color="#4caf50"
            :disabled="!currentWeekday"
          >
            <font-awesome-icon icon="check" />
            Применить
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="preorder-section">
      <v-row>
        <v-col sm="6">
          <div class="weekdays-section d-flex flex-column">
            <week-day-item
              v-for="(weekday, i) in getWeekdays"
              :key="i"
              @update-weekday="updateWeekday"
              :weekday="weekday"
              :is-active="currentWeekday === weekday"
            />
          </div>
        </v-col>
        <v-col sm="6">
          <span
            v-if="currentWeekday"
            class="delivery-summary d-block font-weight-medium mb-5"
          >
            <span class="d-block">Доставка на:</span>
            {{ currentWeekday }} {{ timeFrom.HH }}:{{ timeFrom.mm }} до {{ timeTo.HH }}:{{ timeTo.mm }}
          </span>
          <delivery-time ref="deliveryTime" @on-update="updateTime" :is-same-day="isSameDay" />
        </v-col>
      </v-row>

      <v-row>
        <v-col sm="6">
          <v-btn @click="resetPreorder" depressed dark color="#ff0034" class="button d-block button-cancel-preorder">
            Как можно скорее
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import DeliveryTime from './DeliveryTime'
  import WeekDayItem from './WeekDayItem'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import { formatIsoDateTimeAsDate } from '@/util/date-time-helper'

  export default {
    name: 'PreorderWindow',
    mixins: [mixinSnackbarMessage],
    components: {
      DeliveryTime,
      WeekDayItem,
    },
    data () {
      return {
        currentWeekday: null,
        isSameDay: true,
        timeFrom: {
          HH: '00',
          mm: '00',
        },
        timeTo: {
          HH: '00',
          mm: '00',
        },
      }
    },
    watch: {
      currentWeekday () {
        const currentDay = moment(new Date(Date.now())).format('YYYY-MM-DD')
        const weekDay = moment(this.currentWeekday, 'DD.MM.YYYY').format('YYYY-MM-DD')

        this.isSameDay = moment(currentDay).isSame(weekDay, 'day')
      },
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
      }),
      getWeekdays () {
        const today = moment()
        const weekdays = []
        for (let i = 0; i < 6; i++) {
          weekdays.push(moment(today).add(i, 'days').format('DD.MM.YYYY'))
        }
        return weekdays
      },
    },
    methods: {
      resetPreorder () {
        const id = this.basket.id

        const data = {
          toDatetime: false,
        }

        this.$store.commit('baskets/setBasketLoading', true)

        this.$store.dispatch('baskets/updateBasket', { data, id })
          .then(res => {
            if (res.status === 200) {
              this.showSuccessMessage('Предзаказ отменен')
              this.stepBack()
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          }).finally(() => {
            this.$store.commit('baskets/setBasketLoading', false)
          })
      },
      applyPreorder () {
        let date = moment(this.currentWeekday, 'DD.MM.YYYY').format('YYYY-MM-DD')
        date += ` ${this.timeFrom.HH}:${this.timeFrom.mm}`

        const id = this.basket.id

        const data = {
          toDatetime: true,
          dateDelivery: date,
        }

        this.$store.commit('baskets/setBasketLoading', true)

        this.$store.dispatch('baskets/updateBasket', { data, id })
          .then(res => {
            if (res.status === 200) {
              this.showSuccessMessage('Предзаказ обновлен')
              this.stepBack()
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          }).finally(() => {
            this.$store.commit('baskets/setBasketLoading', false)
          })
      },
      updateWeekday (value) {
        this.currentWeekday = value
      },
      updateTime (date) {
        this.timeFrom = date.timeFrom
        this.timeTo = date.timeTo
      },
      stepBack () {
        this.$store.commit('newOrder/setCurrentOtherWindow', undefined)
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
      },
      setCurrentDay () {
        if (this.basket.toDatetime && this.basket.dateDelivery) {
          this.currentWeekday = formatIsoDateTimeAsDate(this.basket.dateDelivery)
          /* this.timeFrom = {
            HH: moment(this.basket.dateDelivery, 'YYYY-MM-DD HH:mm:ss').format('HH'),
            mm: moment(this.basket.dateDelivery, 'YYYY-MM-DD HH:mm:ss').format('mm'),
          }
          this.$refs.deliveryTime.updateValues(this.timeFrom) */
          // console.log(this.timeFrom)
        } else {
          this.currentWeekday = moment(new Date(Date.now())).format('DD.MM.YYYY')
        }
      },
    },
    mounted () {
      this.setCurrentDay()
    },
  }
</script>

<style lang="less" scoped>
.preorder-window-component {
  .weekdays-section {
    margin-bottom: -15px;
  }
  .step-title {
    font-size: 34px;
    line-height: 21px;
    margin-bottom: 33px;
  }

  .button {
    height: 80px;
    background-color: @color-secondary !important;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      svg {
        .fill-svg(#0033ff);
      }
    }

    // скругление как у «Применить» в остальных окнах оформления
    .button-apply {
      background-color: @color-success !important;
      color: #ffffff;
      border-radius: 10px;

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  .button-cancel-preorder {
    margin-top: 24px;
    font-size: 18px !important;
    border-radius: 10px;
    background-color: #ff0034 !important;
    width: 100%;
  }

  // Компактный десктоп: окно целиком на одном экране. Итоговое время доставки
  // крупнее - это главное, что оператор проговаривает клиенту
  .media-compact-pc({
    .weekdays-section {
      margin-bottom: -12px;
    }

    .delivery-summary {
      font-size: 20px;
      line-height: 1.3;
    }

    .button-cancel-preorder {
      height: 65px;
      margin-top: 12px;
    }
  });
}
</style>
